import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import React, { useState, useEffect } from "react";

const Playlists = () => {
  const [message, setMessage] = useState("");
  const [inputValue, setInputValue] = useState(""); // State to store the text box value
  const [playlistTitle, setPlaylistTitleValue] = useState(""); // State to store the text box value
  const [recommendations, setRecommendations] = useState(null);
  const [movieRecommendations, setMovieRecommendations] = useState(null);
  const [loading, setLoading] = useState(false);
  const [createdPlaylist, setCreatedPlaylist] = useState(false);
  const [userId, setUserId] = useState(false);
  const [error, setError] = useState(null);

  // Slick Carousel settings
  const settings = {
    dots: false, // Show dots for navigation
    infinite: true, // Infinite looping
    speed: 500, // Transition speed
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll
    responsive: [
      {
        breakpoint: 1024, // Adjust for tablets
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600, // Adjust for mobile
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const submitMoviesWithTitle = (title) => {
    if (!title) {
      return;
    }
    // Fetch data from the API when the button is clicked
    setLoading(true);
    fetch(
      `https://soundtrackd-worker.stefangawrys-cloudflare.workers.dev/api/createPlaylist?accessToken=${localStorage.getItem(
        "spotifyAccessToken"
      )}&movies=${title}`
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch data");
        }
        return res.json();
      })
      .then((data) => {
        setRecommendations(JSON.parse(data));
        setLoading(false);
        setCreatedPlaylist(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setError("Failed to generate a playlist."); // Handle errors
        setLoading(false);
        setCreatedPlaylist(false);
      });
  };

  const submitMovies = () => {
    submitMoviesWithTitle(inputValue);
  };

  const savePlaylist = () => {
    setLoading(true);
    fetch(
      `https://soundtrackd-worker.stefangawrys-cloudflare.workers.dev/api/savePlaylist?accessToken=${localStorage.getItem(
        "spotifyAccessToken"
      )}`,
      {
        method: "POST", // Use POST instead of GET
        body: JSON.stringify({
          recommendations, // Pass the song list in the body
          playlist: playlistTitle,
          userId: userId,
        }),
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch data");
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        setCreatedPlaylist(true);
      })
      .catch((error) => {
        console.error("Error:", error);
        setError("Failed to save playlist"); // Handle errors
        setLoading(false);
      });
  };
  const getMovieRecommendations = () => {
    setLoading(true);
    fetch(
      `https://soundtrackd-worker.stefangawrys-cloudflare.workers.dev/api/getMovieRecommendations`
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch data");
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        setMovieRecommendations(data.results);
      })
      .catch((error) => {
        console.error("Error:", error);
        setError("Failed to get movie recommendations."); // Handle errors
        setLoading(false);
      });
  };

  // Handle changes in the text box
  const handleInputChange = (event) => {
    setInputValue(event.target.value); // Update the state with the new input value
  };

  const handlePlaylistTitleChange = (event) => {
    setPlaylistTitleValue(event.target.value); // Update the state with the new input value
  };

  useEffect(() => {
    fetch(
      "https://soundtrackd-worker.stefangawrys-cloudflare.workers.dev/api/me?accessToken=" +
        localStorage.getItem("spotifyAccessToken")
    )
      .then((res) => res.json())
      .then((data) => {
        setUserId(data.id);
        setMessage(data.display_name);
      });
  }, []);

  useEffect(() => {
    getMovieRecommendations();
  }, []);

  useEffect(() => {
    const socket = new WebSocket(
      "wss://soundtrackd-worker.stefangawrys-cloudflare.workers.dev"
    );

    socket.addEventListener("open", () => {
      console.log("WebSocket connection established");
    });

    socket.addEventListener("message", (event) => {
      const data = JSON.parse(event.data);
      console.log(event.data);
      if (data.type === "kv_update") {
        console.log("KV update received:", data.message);
        // Update the UI or trigger a refresh
      }
    });

    socket.addEventListener("close", () => {
      console.log("WebSocket connection closed");
    });
  }, []);

  return (
    <div className="App">
      <h1>Soundtrackd</h1>
      <p class="subtitle">Spotify User: {message}</p>
      <header className="App-header">
        <div class="content">
          <div class="search-container">
            <input
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              class="search-input"
              placeholder="Enter movie titles here"
            />
            <button
              onClick={submitMovies}
              disabled={loading}
              class="search-button"
            >
              {loading ? "Loading..." : "Get Recommendations"}
            </button>
          </div>
          <div className="movie-recommendations-container">
            {movieRecommendations && (
              <Slider {...settings}>
                {movieRecommendations.map((movie, index) => (
                  <div key={index} className="movie-slide">
                    <img
                      src={`https://image.tmdb.org/t/p/w500${movie.backdrop_path}`} // Use backdrop_path for the poster
                      alt={movie.title}
                      className="movie-poster"
                      onClick={() => {
                        submitMoviesWithTitle(movie.title);
                      }}
                    />
                    <h3 className="movie-title">{movie.title}</h3>
                  </div>
                ))}
              </Slider>
            )}
          </div>
          {recommendations && (
            <div class="recommendations-container">
              <div className="song-list">
                <h4>Recommended Songs:</h4>
                <ul class="recommendations-list">
                  {recommendations.songs.map((song, index) => (
                    <li key={index} class="song-item">
                      <div class="play-icon">
                        <svg viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                      <div class="song-details">
                        <p class="song-title">{song.songTitle}</p>
                        <p class="song-artist">{song.artist}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="additional-content">
                <div class="search-container">
                  <input
                    type="text"
                    value={playlistTitle}
                    onChange={handlePlaylistTitleChange}
                    class="search-input"
                    placeholder="Enter playlist title"
                  />
                  <button
                    onClick={savePlaylist}
                    disabled={loading || createdPlaylist}
                    class="search-button"
                  >
                    {loading
                      ? "Loading..."
                      : createdPlaylist
                      ? "Disabled"
                      : "Save Playlist"}
                  </button>
                </div>
              </div>
            </div>
          )}
          <div>{error && <p style={{ color: "red" }}>{error}</p>}</div>
        </div>
      </header>
    </div>
  );
};

export default Playlists;
